import React, { memo, useContext } from 'react'

import { Typography } from '../../../components/common'
import { LanguageContext } from '../../../context/LanguageContext'

const Footer = () => {
    // Contexts
    const { formatString } = useContext(LanguageContext)

    if (['local', 'development'].includes(process.env.REACT_APP_ENV)) {
        console.log(process.env)
    }
    const releaseVerText = formatString('VERSION_VALUE', {
        VALUE: process.env.REACT_APP_ADP_RELEASE_VERSION,
    })

    return (
        <footer className={'footer'}>
            <div className={'footer__release-version'}>
                <Typography text={releaseVerText} />
            </div>
        </footer>
    )
}

export default memo(Footer)
